import { ReduxState } from '../../store';

export const selectScheduleDetails = (state: ReduxState) => state.playerMetaReducer.scheduleDetails;
export const selectBatchDetails = (state: ReduxState) => state.playerMetaReducer.batchDetails;
export const selectOttVideoDetails = (state: ReduxState) => state.playerMetaReducer.ottVideoDetails;
export const selectOttVideoDpps = (state: ReduxState) => state.playerMetaReducer.ottVideoDpps;
export const selectOttPlaylistItems = (state: ReduxState) =>
  state.playerMetaReducer.ottPlaylistItems;
export const selectBookmarkedVideos = (state: ReduxState) =>
  state.playerMetaReducer.bookmarkedVideos || {};
export const selectIsPWOrg = (state: ReduxState): boolean | undefined =>
  state.playerMetaReducer.isPWOrg;
